import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { withRouter } from "react-router";
import DashboardTabs from '../tabs';
import SingleSampleInfoPanel from './infoPanel';
import SingleSampleTermsPanel from '../components/termsPanel';
import api from '@/middlewares/api';

import {ROUTESLIST} from '@/static/urls.js';

import { arrangeOneInfo } from '@/utils/samples.js';
import { arrangeTerms } from '@/utils/terms.js';
import sampleImg  from '@/assets/images/defaults/sample-big1.png';

import './index.scss';

class DashboardOneSamplePage extends Component {
    constructor(props) {
        super(props);        
        //TODO setCount data can change
        this.state = {           
            tabs: [
                {id: 'about', isCount: false, label: 'About'},
                {id: 'data', isCount: false, label: 'Terms'},
            ],
            isLoaded: false,
            item: null,
            terms: null,            
        }    
    }
    componentDidMount() {
        this.fetchItem();
        this.fetchTerms();
    }

    fetchTerms() {
        const { match } = this.props;
        const id = match.params.id;
        if(! id) return;
        api.get('user/dashboard/clear-sample/terms/show/' + id)
        .then((response) => { //console.log('sample terms', response.data);
            const terms = arrangeTerms(response.data);
            this.setState({
                terms: terms
            });
        })
        .catch((err) => {
            console.log(err.response);        
        });     
    }

    fetchItem() {
        const { match } = this.props;
        const id = match.params.id;
        if(! id) return;
        api.get('user/dashboard/clear-sample/show/' + id)
        .then((response) => { //console.log('sample', response.data);
            const item = arrangeOneInfo(response.data);
            this.setState({item: item, isLoaded: true})
        })
        .catch((err) => {
            console.log(err.response);        
        });     
    }

    render() { 
        const { tabs, item, isLoaded, terms } = this.state;  
        if(! item ) return null;   
        return (
            <div> 
            <h3 className="dashboard-header dashboard-header_small dashboard-header_left-link">
                <Link to={ROUTESLIST.DASHBOARD_SAMPLES} className="btn btn-act-iconed">
                    <i className="as-icon as-icon_nav-left"></i>
                </Link> 
                {
                    isLoaded &&
                    <span>{ item.title }</span> 
                }  
                               
            </h3>
            <div className="db-single-img">
                <img src={ sampleImg } alt="" />
            </div>
            <DashboardTabs 
                    items={tabs}
                    panels={
                        [
                            <SingleSampleInfoPanel item={ item } />,
                            <SingleSampleTermsPanel terms={ terms } />
                        ]
                    }
            /> 
             
        </div> 
        )
    }
}
export  default withRouter(DashboardOneSamplePage);